module.exports = __webpack_public_path__ + "img/person_3.15cfd62.webp";